import { render, staticRenderFns } from "./english-mock-prompt.vue?vue&type=template&id=77772888&scoped=true&"
import script from "./english-mock-prompt.vue?vue&type=script&lang=js&"
export * from "./english-mock-prompt.vue?vue&type=script&lang=js&"
import style0 from "./english-mock-prompt.vue?vue&type=style&index=0&id=77772888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77772888",
  null
  
)

export default component.exports